<ng-container *transloco="let t">
    <ng-container
        *ngIf="{
            required: required$ | async,
            optionList: options$ | async,
            values: values.$ | async,
            disabled: disabled.$ | async,
        } as data"
    >
        <div
            *ngIf="ngControl.control; let control"
            [class]="'bazis-control ' + cssClassSizeControl"
            [ngClass]="{
                'bazis-control--invalid': ngControl.control.invalid,
                'bazis-control--disabled': data.disabled,
                'bazis-control--dirty': ngControl.control.dirty,
                'bazis-control--empty':
                    emptyValues.indexOf(ngControl.control.value) > -1 ||
                    (multiple && !ngControl.control.value?.length),
            }"
        >
            <bazis-label
                [isMajor]="hasTitleMajor"
                [isEmptyLabel]="isEmptyLabel"
                [title]="title || t(titleKey, titleParams)"
                [required]="data.required"
            >
                <bazis-interrogation
                    *ngIf="tooltipKey"
                    [slot]="tooltipSettings?.targetSide"
                    iconSize="compact"
                    [tooltipText]="t(tooltipKey, tooltipParams)"
                    [tooltipOffset]="[-8, 4]"
                    [tooltipEventType]="tooltipSettings?.eventType || 'hover'"
                    [tooltipPlacement]="tooltipSettings?.placement || 'top-start'"
                    [icon]="icons.interrogation"
                    [type]="interrogationType"
                ></bazis-interrogation>
            </bazis-label>

            <div class="bazis-selectable-cards">
                <div
                    *ngFor="let option of data.optionList; let i = index"
                    class="bazis-selectable-card"
                >
                    <label (click)="toggleValue(option.id)">
                        <input
                            [type]="multiple || forceCheckbox ? 'checkbox' : 'radio'"
                            [disabled]="data.disabled"
                            [checked]="data.values.indexOf(option.id) > -1"
                            (change)="preventDefault($event)"
                            (click)="preventDefault($event)"
                        />
                        <span class="bazis-selectable-cards__item">
                            <span class="bazis-selectable-cards__item__title">
                                <ng-container *ngIf="option.$snapshot.name">
                                    {{ option.$snapshot.name }}
                                </ng-container>
                                <ng-container *ngIf="option.$snapshot.nameKey">
                                    {{ t(option.$snapshot.nameKey, option.$snapshot.nameParams) }}
                                </ng-container>
                                <bazis-icon
                                    *ngIf="option.$snapshot.icon"
                                    [icon]="option.$snapshot.icon"
                                    size="large"
                                ></bazis-icon>
                            </span>
                            <span
                                *ngIf="option.$snapshot.note"
                                class="bazis-selectable-cards__item__description"
                            >
                                {{ option.$snapshot.note }}
                            </span>
                        </span>
                    </label>
                </div>
            </div>
        </div>
    </ng-container>
</ng-container>
